export const tPath = 'currentWeatherConditionsPage.currentWeatherHeader';
export const CurrentWeatherHeaderTestIds = {
  city: 'current-weather-header-city',
};
